import { cva } from 'class-variance-authority';
import { useTranslation } from 'react-i18next';

const perPageBtn = cva(
  'rounded-md font-medium border-none transition-colors whitespace-nowrap cursor-pointer',
  {
    variants: {
      active: {
        true: 'bg-brand/10 text-brand font-semibold',
        false:
          'bg-transparent text-muted-foreground hover:bg-muted hover:text-foreground',
      },
      size: {
        md: 'h-8 min-w-8 px-2 text-sm',
        sm: 'h-7 min-w-7 px-2 text-xs',
      },
    },
    defaultVariants: { active: false, size: 'md' },
  },
);

const PER_PAGE_OPTIONS = [12, 24, 48, 100, 500];

type Props = {
  perPage: number;
  size: 'sm' | 'md';
  onSelect: (perPage: number) => void;
};

const PerPagePills = ({ perPage, size, onSelect }: Props) => {
  const { t } = useTranslation('misc', { keyPrefix: 'pagination' });

  return (
    <div className={`flex items-center ${size === 'sm' ? 'gap-1' : 'gap-2'}`}>
      <span
        className={`${
          size === 'sm' ? 'text-xs' : 'text-sm'
        } text-muted-foreground whitespace-nowrap`}
      >
        {t('perPage')}
      </span>
      <div
        className={`flex items-center ${size === 'sm' ? 'gap-0.5' : 'gap-1'}`}
      >
        {PER_PAGE_OPTIONS.map((opt) => (
          <button
            key={opt}
            type="button"
            onClick={() => onSelect(opt)}
            className={perPageBtn({ active: perPage === opt, size })}
          >
            {opt}
          </button>
        ))}
      </div>
    </div>
  );
};

export default PerPagePills;
